import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectTemplateApi } from 'container/projectTemplateApi';
import { ProjectKind } from 'model/ProjectKind';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from './initialState';

export const fetchPulseSurveyTemplateLibrary = createAsyncThunk(
  `${STORE_NAME}/fetch`,
  ({
    page,
    limit,
    circleId,
    sort,
  }: {
    page: number;
    limit: number;
    circleId?: string;
    sort?: string;
  }) =>
    projectTemplateApi.listPaginated({
      page,
      limit,
      circleId,
      kind: ProjectKind.PULSE_PROJECT,
      sort,
    }),
  { serializeError },
);

export const deletePulseSurveyTemplate = createAsyncThunk(
  `${STORE_NAME}/delete`,
  (id: number) => projectTemplateApi.delete(id),
  { serializeError },
);

export const previewPulseSurveyTemplateImport = createAsyncThunk(
  `${STORE_NAME}/importPreview`,
  (file: File) => projectTemplateApi.importPreview(file),
  { serializeError },
);

export const importPulseSurveyTemplate = createAsyncThunk(
  `${STORE_NAME}/import`,
  ({ circleId, file }: { circleId: string; file: File }) =>
    projectTemplateApi.import(circleId, file),
  { serializeError },
);
